import React from "react";

const title = {
  seller: "Seller Portal",
  buyer: "Buyer Portal",
  trader: "Trader Portal"
};

const images = ["/images/seller-wall.png", "/images/portal2.jpg"];

const SignupWall = ({ portal, ReSetPassword = false, children }) => {
  const bg = {
    seller: images[0],
    buyer: images[0],
    trader: images[0]
  };

  const bgImage = ReSetPassword ? images[0] : bg[portal];

  return (
    <div className="h-full max-h-screen sticky right-0 top-0 p-2">
      <div
        className={`flex flex-col bg-cover py-16 px-4 h-full rounded-xl items-center`}
        style={{
          backgroundImage: `url(${bgImage})`
        }}
      >
        {!ReSetPassword && (
          <h2 className="text-3xl font-medium mb-4">{title[portal]}</h2>
        )}
        <h2 className="text-5xl font-medium text-center">Welcome</h2>
        <p className="text-xl text-center leading-10">To Offsetgo</p>
        <p className="text-xl text-center">
          World's first Blockchain based carbon trading platform
        </p>
        <div className="mt-96 ">{children}</div>
      </div>
    </div>
  );
};

export default SignupWall;
